var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent, Children } from 'react';
import * as idleCallback from '../../util/idle-callback';
import Arrow from './arrow';
import InViewport from '../context/in-viewport';
import { getSteps, getInViewportSlides } from './util';
import * as CLS from './cls';

var Slider = function (_PureComponent) {
    _inherits(Slider, _PureComponent);

    function Slider() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Slider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            page: 0,
            steps: [0],
            animated: false,
            rowsRects: [],
            inViewport: []
        }, _this.requestId = -1, _this.handleNextClick = function () {
            _this.setPage(_this.state.page + 1);
        }, _this.handlePrevClick = function () {
            _this.setPage(_this.state.page - 1);
        }, _this.setWrapperRef = function (ref) {
            return _this.wrapperRef = ref;
        }, _this.setContainerRef = function (ref) {
            return _this.containerRef = ref;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Slider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.requestId = idleCallback.request(function () {
                return _this2.layout();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            idleCallback.cancel(this.requestId);
        }
    }, {
        key: 'setPage',
        value: function setPage(page) {
            var _state = this.state,
                rowsRects = _state.rowsRects,
                steps = _state.steps,
                containerWidth = _state.containerWidth;


            this.setState({
                page: page,
                animated: true,
                inViewport: getInViewportSlides({
                    rowsRects: rowsRects,
                    page: page,
                    steps: steps,
                    containerWidth: containerWidth,
                    gap: this.props.gap,
                    inViewport: this.state.inViewport
                })
            });
        }
    }, {
        key: 'layout',
        value: function layout() {
            var gap = this.props.gap;

            var containerRect = this.containerRef.getBoundingClientRect();
            var rowsRects = Array.prototype.slice.call(this.wrapperRef.children).map(function (node) {
                return node.getBoundingClientRect();
            });

            var steps = getSteps([rowsRects], containerRect, gap);

            var localRowsRects = rowsRects.map(function (_ref2) {
                var left = _ref2.left,
                    right = _ref2.right;
                return {
                    left: left - containerRect.left,
                    right: right - containerRect.left
                };
            });

            var inViewport = getInViewportSlides({
                steps: steps,
                page: 0,
                rowsRects: localRowsRects,
                containerWidth: containerRect.width,
                gap: gap
            });

            this.setState({
                steps: steps,
                page: 0,
                rowsRects: localRowsRects,
                inViewport: inViewport,
                containerWidth: containerRect.width
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var state = this.state;
            var page = state.page,
                steps = state.steps,
                animated = state.animated,
                inViewport = state.inViewport;

            var step = steps[page];
            var singlePage = steps.length === 1;
            var transform = 'translateX(' + step + 'px)';
            var showLeftArrow = !singlePage && page > 0;
            var showRightArrow = !singlePage && page < steps.length - 1;

            return React.createElement(
                'div',
                {
                    className: CLS.slider.mix(props.className)()
                },
                React.createElement(Arrow, {
                    left: true,
                    visible: showLeftArrow,
                    onClick: this.handlePrevClick
                }),
                React.createElement(
                    'div',
                    {
                        className: CLS.container,
                        ref: this.setContainerRef
                    },
                    React.createElement(
                        'div',
                        {
                            className: CLS.wrapper({
                                animated: animated
                            })(),
                            style: { transform: transform },
                            ref: this.setWrapperRef
                        },
                        Children.map(props.children, function (child, index) {
                            return React.createElement(
                                InViewport.Provider,
                                { value: inViewport[index] },
                                child
                            );
                        })
                    )
                ),
                React.createElement(Arrow, {
                    right: true,
                    visible: showRightArrow,
                    onClick: this.handleNextClick
                })
            );
        }
    }]);

    return Slider;
}(PureComponent);

export default Slider;